/** User role as returned by the API (e.g. /api/v1/users). */
export enum UserRole {
  EMPLOYEE = 'ROLE_EMPLOYEE',
  OFFICE_MANAGER = 'ROLE_OFFICE_MANAGER',
}
